import { ApiError } from '@/api/client';

/** User-facing text for LLM gateway failures (settings may still show "configured"). */
export function llmErrorMessage(err: unknown, fallback = 'LLM niet beschikbaar.'): string {
  if (!(err instanceof ApiError)) {
    return err instanceof Error ? err.message : fallback;
  }
  if (err.code === 'AI_PROVIDER_CREDITS') return err.message;
  if (err.code === 'LLM_BUDGET_EXCEEDED') {
    return 'LLM-maandbudget bereikt voor dit project.';
  }
  if (err.code === 'AI_PARSE_FAILED') {
    return err.message || 'AI-antwoord kon niet worden verwerkt. Probeer opnieuw.';
  }
  if (err.code === 'AI_UNAVAILABLE') {
    return err.message || 'LLM tijdelijk niet beschikbaar — zie Instellingen → Platform.';
  }
  return err.message || fallback;
}
